import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query positionExemptStatuses ($sort: SortFindManyPosition_Exempt_StatusInput) {
    lookups {
      Position_Exempt_Status {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type PositionExemptStatuses = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['Position_Exempt_Status']>['many']>

const usePositionExemptStatuses = (): PositionExemptStatuses => {
  const { data } = useGraphQL(document)
  const statuses = data?.lookups?.Position_Exempt_Status?.many
  return statuses ?? []
}

export { usePositionExemptStatuses, document as positionExemptStatusDocument }
